import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Form,
  DatePicker,
  Typography,
  message,
  Spin,
  Select,
} from "antd";
import { get, put } from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

const { Title } = Typography;
const { Option } = Select;

const PlatformCouponsEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    get(`makan-coupons/${id}`).then((res) => {
      const data = res.data;

      form.setFieldsValue({
        code: data.code,
        night: data.night,
        days: Number(data.days), // ✅ مهم
        start_date: dayjs(data.start_date),
        end_date: dayjs(data.end_date),
      });

      setPageLoading(false);
    });
  }, []);

  const onFinish = (values) => {
    setLoading(true);

    const payload = {
      code: values.code,
      night: values.night,
      days: values.days, // ✅ جديد
      start_date: values.start_date.format("YYYY-MM-DD"),
      end_date: values.end_date.format("YYYY-MM-DD"),
    };

    put(`makan-coupons/${id}`, payload)
      .then(() => {
        message.success("تم التعديل بنجاح");
        navigate("/platform-coupons");
      })
      .catch((err) => {
        message.error(err.response?.data?.message || "خطأ");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Title level={2}>تعديل كوبون</Title>

      {pageLoading ? (
        <Spin />
      ) : (
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item name="code" label="الكود" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item
            name="night"
            label="نسبة الخصم"
            rules={[{ required: true }]}
          >
            <Input type="number" />
          </Form.Item>

          {/* ✅ days */}
          <Form.Item
            name="days"
            label="عدد الأيام"
            rules={[{ required: true }]}
          >
            <Select placeholder="اختر عدد الأيام">
              {[...Array(10)].map((_, i) => (
                <Option key={i + 1} value={i + 1}>
                  {i + 1}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="start_date"
            label="تاريخ البداية"
            rules={[{ required: true }]}
          >
            <DatePicker className="w-100" />
          </Form.Item>

          <Form.Item
            name="end_date"
            label="تاريخ النهاية"
            rules={[{ required: true }]}
          >
            <DatePicker className="w-100" />
          </Form.Item>

          <Button type="primary" htmlType="submit" loading={loading} block>
            تعديل
          </Button>
        </Form>
      )}
    </div>
  );
};

export default PlatformCouponsEdit;
